import React, { useContext } from 'react';
import { useTitle } from 'components/StudioLayout/StudioLayout';
import { UserContext } from 'components/UserContext';
import { useOrganizationAnalytics } from 'controllers/react-query/organizationHooks';
import { Grid } from '@mui/material';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { OrganizationAnalyticsCard } from './OrganizationAnalyticsCard/OrganizationAnalyticsCard';

export const OrganizationAnalytics = () => {
  const { user } = useContext(UserContext);

  const {
    data: analyticsData,
    isFetching: isFetchingAnalytics,
    isError: isErrorAnalytics,
  } = useOrganizationAnalytics(user?.active_organization?.id);

  useTitle(analyticsData ? `${analyticsData.name} Analytics` : '');

  if (isFetchingAnalytics) {
    return <LoadingIndicator message='Loading analytics...' />;
  }

  if (isErrorAnalytics) {
    return <div>Error fetching data. {isErrorAnalytics} </div>;
  }

  if (!analyticsData) {
    return <div>No analytics data available.</div>;
  }

  return (
    <div>
      <Grid container spacing={2} justifyContent='flex-start'>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.member_count} label='Members' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.lesson_collections_count} label='Active Lessons' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.lesson_creators_count} label='Lesson Creators' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.unique_lti_players} label='Unique LTI Players' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.unique_players} label='Unique Kyron Players' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.lesson_completions_count} label='Lessons Completed' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.lesson_instances_count} label='Lessons Attempted' />
        </Grid>
        <Grid item>
          <OrganizationAnalyticsCard number={analyticsData.completion_rate} label='Lesson Completion %' />
        </Grid>
      </Grid>
    </div>
  );
};
